<template>
  <div :class="`iqos-scroll-with-actions gap-row-${paddingSize}`">
    <IQOSHorizontalScroll :height="autoHeight ? 'auto' : undefined" :barGap="barGap" :elementCount="elementCount" :scrollContainerStyles="scrollContainerStyles">
        <slot />
    </IQOSHorizontalScroll>

    <div :class="{
        'iqos-scrollbar-actions': canShowActions
    }">
        <slot name="actions" />
    </div>
  </div>
</template>

<script>
export default {
    props: {
        elementCount: {
            type: Number,
        },
        scrollContainerStyles: {
            type: Object,
            default: {}
        },
        paddingSize: {
            type: String,
            default: 'md'
        },
        barGap: {
            type: String,
            default: 'sm'
        },
        autoHeight: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        canShowActions() {
            return this.$slots.actions && !!this.$slots.actions.find(vnode => {
                return !!vnode.tag;
            });
        }
    }
}
</script>

<style scoped>
.scroller-actions {
    padding-left: 40px;
    padding-right: 40px;
    padding-bottom: 24px;
    width: 100%;
    display: flex;
}
</style>